"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listReasonsQuerySchema = exports.updateDisallowanceReasonSchema = exports.createDisallowanceReasonSchema = exports.listDisallowancesQuerySchema = exports.markCollectedSchema = exports.rejectWriteOffSchema = exports.approveWriteOffSchema = exports.recordDisallowanceSchema = exports.statementParamsSchema = exports.payableClaimsQuerySchema = exports.listRemittancesQuerySchema = exports.reverseRemittanceSchema = exports.recordRemittanceSchema = exports.ipRemittanceStatusEnum = exports.ipDisallowanceStatusEnum = exports.ipDisallowanceActionEnum = exports.ipRemittanceModeEnum = void 0;
const zod_1 = require("zod");
/**
 * INSURANCE MODULE, PHASE 4 (ADR-098) — insurer payments, shortfalls and receivables.
 *
 * Amounts are integer paise.
 */
exports.ipRemittanceModeEnum = zod_1.z.enum(['BANK_TRANSFER', 'CHEQUE', 'UPI', 'OTHER']);
exports.ipDisallowanceActionEnum = zod_1.z.enum(['BILL_PATIENT', 'WRITE_OFF']);
exports.ipDisallowanceStatusEnum = zod_1.z.enum(['PENDING_APPROVAL', 'POSTED', 'REJECTED']);
exports.ipRemittanceStatusEnum = zod_1.z.enum(['POSTED', 'REVERSED']);
const paise = zod_1.z.number().int().max(100_000_000_000);
exports.recordRemittanceSchema = zod_1.z.object({
    /** Who paid: the insurer, or the TPA acting for it. */
    payerId: zod_1.z.string().uuid(),
    bankAccountId: zod_1.z.string().uuid(),
    mode: exports.ipRemittanceModeEnum.default('BANK_TRANSFER'),
    /** The bank's own reference: UTR, or the cheque number. */
    utr: zod_1.z.string().trim().min(3).max(60),
    receivedOn: zod_1.z.coerce.date(),
    /** The bank credit, as read off the statement. Must equal the claims paid less the TDS withheld. */
    netAmount: paise.min(0),
    notes: zod_1.z.string().trim().max(1000).optional(),
    lines: zod_1.z
        .array(zod_1.z.object({
        claimId: zod_1.z.string().uuid(),
        paidAmount: paise.positive(),
        tdsAmount: paise.min(0).default(0),
    }))
        .min(1)
        .max(200),
});
exports.reverseRemittanceSchema = zod_1.z.object({ reason: zod_1.z.string().trim().min(3).max(1000) });
exports.listRemittancesQuerySchema = zod_1.z.object({
    payerId: zod_1.z.string().uuid().optional(),
    status: exports.ipRemittanceStatusEnum.optional(),
    /** Remittance number or the bank's reference. */
    q: zod_1.z.string().trim().max(100).optional(),
    page: zod_1.z.coerce.number().int().min(1).optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(200).optional(),
});
exports.payableClaimsQuerySchema = zod_1.z.object({ payerId: zod_1.z.string().uuid() });
exports.statementParamsSchema = zod_1.z.object({ payerId: zod_1.z.string().uuid() });
// ---- shortfalls
exports.recordDisallowanceSchema = zod_1.z.object({
    amount: paise.positive(),
    reasonId: zod_1.z.string().uuid(),
    /** Omit to use the reason's standing answer, when finance has set one. */
    action: exports.ipDisallowanceActionEnum.optional(),
    /** Required when the desk chooses against the reason's standing answer. */
    note: zod_1.z.string().trim().max(1000).optional(),
});
exports.approveWriteOffSchema = zod_1.z.object({ note: zod_1.z.string().trim().max(1000).optional() });
exports.rejectWriteOffSchema = zod_1.z.object({ note: zod_1.z.string().trim().min(3).max(1000) });
exports.markCollectedSchema = zod_1.z.object({ reference: zod_1.z.string().trim().min(2).max(100) });
exports.listDisallowancesQuerySchema = zod_1.z.object({
    status: exports.ipDisallowanceStatusEnum.optional(),
    action: exports.ipDisallowanceActionEnum.optional(),
    /** `true` = amounts billed to the patient and not yet collected. */
    toCollect: zod_1.z.enum(['true', 'false']).optional(),
    claimId: zod_1.z.string().uuid().optional(),
    page: zod_1.z.coerce.number().int().min(1).optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(200).optional(),
});
exports.createDisallowanceReasonSchema = zod_1.z.object({
    code: zod_1.z
        .string()
        .trim()
        .transform((v) => v.toUpperCase())
        .pipe(zod_1.z.string().regex(/^[A-Z0-9][A-Z0-9_]{1,29}$/, 'Code is 2-30 letters, digits or underscore.')),
    name: zod_1.z.string().trim().min(2).max(150),
    /** Null until finance decides what the hospital does with this kind of shortfall. */
    defaultAction: exports.ipDisallowanceActionEnum.nullable().optional(),
});
exports.updateDisallowanceReasonSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(2).max(150).optional(),
    defaultAction: exports.ipDisallowanceActionEnum.nullable().optional(),
    isActive: zod_1.z.boolean().optional(),
});
exports.listReasonsQuerySchema = zod_1.z.object({ includeInactive: zod_1.z.enum(['true', 'false']).optional() });
//# sourceMappingURL=insurance-receipts.schema.js.map